import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faCheckCircle,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { Form, Button, InputGroup, Alert } from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";

import AuthSplitLayout from "../../components/AuthSplitLayout";
import { Routes } from "../../routes";
import { _postApi } from "../../redux/Functions";
import { apiURL } from "../../redux/api";

const ForgotPassword = () => {
  const [form, setForm] = useState({ email: "" });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const getRememberedMail = () => {
    let rememberedUser = localStorage.getItem("@@pharmpay_rem_email") || "";
    setForm({ email: rememberedUser });
  };

  useEffect(() => {
    getRememberedMail();
  }, []);

  const handleChange = ({ target: { value, name } }) => {
    setForm((prev) => ({ ...prev, [name]: value }));
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    _postApi(
      `${apiURL}/api/users/password-reset`,
      { email: form.email },
      (data) => {
        setLoading(false);
        if (data.success) {
          setMessage(
            "Your password reset link has been sent to the provided email and the registered phone number."
          );
        } else {
          setMessage("Check your mails");
        }
      },
      (err) => {
        setLoading(false);
        setError("An error occurred, try again later.");
      }
    );
  };

  const formIsValid = form.email.trim() !== "";

  return (
    <AuthSplitLayout>
      <div className="auth-intro">
        <span className="auth-intro-kicker">Account recovery</span>
        <h1 className="auth-intro-title">Forgot your password?</h1>
        <p className="auth-intro-text">
          Enter the email address on your KIFMIS account and we will send you a
          link to reset your password.
        </p>
      </div>

      {!message && (
        <Form onSubmit={handleSubmit}>
          <Form.Group id="email" className="mb-4">
            <Form.Label>Email address</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faEnvelope} />
              </InputGroup.Text>
              <Form.Control
                required
                autoFocus
                type="email"
                name="email"
                autoComplete="email"
                placeholder="name@katsinastate.gov.ng"
                value={form.email}
                onChange={handleChange}
              />
            </InputGroup>
          </Form.Group>

          {error && (
            <Alert variant="danger" className="text-center py-2">
              {error}
            </Alert>
          )}

          <Button
            variant="primary"
            type="submit"
            className="w-100"
            disabled={!formIsValid || loading}
          >
            {loading ? "Sending link..." : "Send reset link"}
          </Button>
        </Form>
      )}

      {message && (
        <div className="auth-feedback">
          <FontAwesomeIcon icon={faCheckCircle} />
          <p>{message}</p>
        </div>
      )}

      <p className="auth-back-link">
        <Link to={Routes.Signin.path}>
          <FontAwesomeIcon icon={faAngleLeft} />
          Back to sign in
        </Link>
      </p>
    </AuthSplitLayout>
  );
};

export default ForgotPassword;
